import type { HealthResponse } from '@shared/types';

// In production the SPA is served by the same Worker that hosts /api, so a
// relative base works. For the Tauri build (different origin) set
// VITE_API_BASE to the deployed Worker URL at build time.
const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');

/** Absolute URL for an API path (used for full-page redirects like OAuth). */
export const apiUrl = (path: string): string => `${API_BASE}${path}`;

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    // Send the session cookie on same-origin web requests.
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
    ...init,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new ApiError(res.status, text || res.statusText);
  }
  return res.json() as Promise<T>;
}

export const getHealth = () => api<HealthResponse>('/api/health');
